module.exports = __webpack_public_path__ + "img/ic_cooperativa.0b884a4a.svg";